module.exports = __webpack_public_path__ + "img/my.3e0c9683.svg";